export default {
  customerList : state => state.customerList,
  orderDetail : state => state.customerList,
  historyOrderList : state => state.historyOrderList,
  reportList : state => state.reportList,
  isCheckAll: state => state.isCheckAll,
  hasChecked: state => state.hasChecked,
  hasDeleteItem: state => state.hasDeleteItem,
  timeKeepingList : state => state.timeKeepingList,
  payrollData: state => state.payrollData,
  payrollSetting: state => state.payrollSetting,
  discountSetting: state => state.discountSetting,
  cashDiscountSetting: state => state.cashDiscountSetting,
  incomeDetail: state => state.incomeDetail,
  approvePayrollData: state => state.approvePayrollData,
  salaryChartData: state => state.salaryChartData,
  calculatedOrder: state => state.calculatedOrder,
  checkedGiftCardData: state => state.checkedGiftCardData,
  salaryDetail: state => state.salaryDetail,

  //ticket template
  ticketList: state => state.ticketList,
  blockList: state => state.blockList,

  //batch history
  batchHistory: state => state.batchHistory,
  batchDetail: state => state.batchDetail,

  //income history
  incomeHistory: state => state.incomeHistory,

  //staff daily income
  staffDailyIncome: state => state.staffDailyIncome
}
